// eslint-disable-next-line no-shadow
export enum StartupEmployeesQuantity {
  Q_1TO10 = '1-10',
  Q_11TO50 = '11-50',
  Q_51TO100 = '51-100',
  Q_101TO200 = '101-200',
  Q_200PLUS = '200+',
}
